export enum ServiceCaseUpdateScope {
  UPDATE_METADATA,
  UPDATE_JOB,
  DELETE_JOB
}